// extracted by mini-css-extract-plugin
export var icon = "index-module--icon--78138";
export var wrapper = "index-module--wrapper--f92e4";